import { render } from "./App.vue?vue&type=template&id=5180b988"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5180b988&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__